import type { FaireProductEntity } from "../../entity_types/product";

export const p_cghmrnd49u: FaireProductEntity = {
  token: "p_cghmrnd49u",
  type: "product",
  name: "Two Tone Glossy 18K Gold Plated S.Steel Hoop Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/0a97a5da5beebedd7e338ef70543babc11a6df9fe99cccb52c26dee5f0928a29.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3ff37a984159a6e44523fafa4e5ee59bdf7ccbe977bf8d7b0e1dd27500733057.jpeg",
    "https://cdn.faire.com/fastly/5c23f4efa557d95c7537f3daa813c6ab42a44151e11e28fc60a609ad8d65f1ff.jpeg",
    "https://cdn.faire.com/fastly/06ba9105621107fe5d332d0527ae24e197de8d9bfe401a22d70cde6f1d8659e9.jpeg",
  ],
  priceDollars: 10.21,
  description:
    "Type: Earrings\nMaterial : Stainless steel ,18K gold plated\nSize :21mm*30mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 25.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:17.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
